import {Col, Row} from "react-bootstrap";
import elements from "../../styles/settings/elements.module.scss";
import {useDispatch, useSelector} from "react-redux";
import {selectApp} from "../../storage/slicers/appSlice";
import {NavLink} from "react-router-dom";
import {paths} from "../../storage/paths";

export default function Products({ count }){

    const dispatch = useDispatch();
    const appState = useSelector(selectApp);

    let list;
    if (count) {
        const products = appState.products;
        list = [];

        for (let i = 0; i < count; i++) {
            list.push(
                <Col key={products[i].id}>
                    <NavLink to={`/products/${products[i].id}`} className={elements.navLink}>
                        <div className={elements.itemBlock}>
                            <img src={products[i].image} className={elements.itemImg} alt={products[i].title} />
                            <div className={elements.itemDescription}>
                                <p>{products[i].title}</p>
                                <p>{products[i].description}</p>
                                <p>{products[i].price}$</p>
                                <p className={elements.addButton}>ADD +</p>
                            </div>
                        </div>
                    </NavLink>
                </Col>
            );
        }
    } else {
        list = appState.products.map((product) => (
            <Col key={product.id}>
                <NavLink to={`/products/${product.id}`} className={elements.navLink}>
                    <div className={elements.itemBlock}>
                        <img src={product.image} className={elements.itemImg} alt={product.title} />
                        <div className={elements.itemDescription}>
                            <p>{product.title}</p>
                            <p>{product.description}</p>
                            <p>{product.price}$</p>
                            <p className={elements.addButton}>ADD +</p>
                        </div>
                    </div>
                </NavLink>
            </Col>
        ));
    }

    if(count){
        return(
            <Row>
                {list}

                <NavLink to={paths.shop} className={elements.navLink}><button className={`${elements.moreBtn} ${elements.blockDivider}`}>MORE</button></NavLink>
            </Row>
        );
    }
    else{
        return(
            <Row>
                {list}
            </Row>
        );
    }
}